// extracted by mini-css-extract-plugin
export default {"wrapper":"_1iQ8S","dot":"_1Anm9","tooltip-content":"NDo4Q","tooltipContent":"NDo4Q"};